/*
 * ⚠️  CRITICAL - DO NOT DELETE THIS FILE ⚠️
 *
 * Este archivo ES NECESARIO para que Webpack compile correctamente.
 *
 * RAZÓN: app/javascript/packs/application.js tiene la línea:
 *   import "./channels"
 *
 * Si este archivo se elimina:
 *   ❌ Webpack fallará al compilar JavaScript
 *   ❌ Los tests de features fallarán
 *   ❌ Los filtros y elementos interactivos dejarán de funcionar
 *   ❌ La aplicación se romperá en producción
 *
 * CONTEXTO: Eliminamos Action Cable y canales WebSocket, pero mantenemos
 * el import por compatibilidad. El polling HTTP ha reemplazado los WebSockets.
 *
 * ALTERNATIVAS:
 *   1. Mantener este archivo (RECOMENDADO - actual)
 *   2. Eliminar import "./channels" de application.js (requiere más testing)
 *
 * Última actualización: septiembre 2025
 * Commit que rompió sin este archivo: 6694b773040bdcccfc9924634592ed6d8f0b2f81
 */

// No hay canales activos - Action Cable eliminado
export default {};
